import Table from "PFComponents/table";
import { Booking } from "PFTypes";

import { useBookingsListColumnsGenerator } from "./use_bookings_list_columns_generator";

type BookingItem = Booking & { disabled?: boolean; message?: string };

type BookingsTableProps = {
  bookings: BookingItem[];
  isDense?: boolean;
  simplePaginationEnabled?: boolean;
  simplePaginationPageSize?: number;
} & (
  | {
      withActions: true;
      checkCanEditBooking: (booking: BookingItem) => boolean;
      onBookingClick: (booking: BookingItem) => void;
      onBookingEdit?: (booking: BookingItem) => void;
      onBookingDelete?: VoidFunction;
    }
  | {
      withActions?: false;
      checkCanEditBooking?: never;
      onBookingClick?: never;
      onBookingEdit?: never;
      onBookingDelete?: never;
    }
);

export const BookingsTable = ({
  bookings,
  checkCanEditBooking,
  onBookingClick,
  onBookingEdit,
  onBookingDelete,
  isDense,
  withActions,
  simplePaginationEnabled,
  simplePaginationPageSize
}: BookingsTableProps) => {
  const generateColumns = useBookingsListColumnsGenerator({
    onBookingEdit,
    onBookingDelete,
    checkCanEditBooking,
    isDense,
    withActions
  });

  return (
    <Table<BookingItem>
      tableData={bookings}
      generateColumns={generateColumns}
      onRowClick={onBookingClick}
      disableAutoResizing
      simplePaginationEnabled={simplePaginationEnabled}
      simplePaginationPageSize={simplePaginationPageSize}
    />
  );
};
